// extracted by mini-css-extract-plugin
export default {"home":"styles_home__k9z6j"};